// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2v4FY","amount":"Amount_amount__1Kvxr","tip":"Amount_tip__LvyJs","tipHeader":"Amount_tipHeader__3RZFY","tipsWrap":"Amount_tipsWrap__1xntp"};